import React from 'react';
import useMobileMode from '../../../Hooks/useMobileMode';
import DesktopLoginFormPage from '../DesktopLoginFormPage';
import MobileLoginFormPage from '../MobileLoginFormPage';

/**
 * LoginFormPage — renders the mobile mockup login when the mobile layout is
 * active, otherwise the desktop split-screen login. Both share the same props
 * and auth flow (see MOBILE_PLAN.md §F(1)).
 */
const LoginFormPage = function LoginFormPage(props) {
  const mobileMode = useMobileMode();

  return mobileMode ? (
    <MobileLoginFormPage {...props} />
  ) : (
    <DesktopLoginFormPage {...props} />
  );
};

export default LoginFormPage;
